import React, { useState } from "react";
import css from "./Homepage.module.css";
import { speciesList } from "../Panelview/List";
import { relativeURL } from "../../relativeURL";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "react-bootstrap";
import Spinner from "../Spinner";
import { useLookUp } from "../../hooks/lookup";

const SearchByGenes = () => {
  const [species, setSpecies] = useState("hsapiens");
  const [nodeType, setNodeType] = useState("SYMBOL");
  const [content, setContent] = useState("");
  const [pathwaysResults, setPathwaysResults] = useState({
    status: false,
    computing: false,
    results: [],
  });

  const onSubmit = (event) => {
    setPathwaysResults({
      status: false,
      computing: true,
      results: [],
    });
    SearchByGenesHook();
    event.preventDefault();
  };

  const onChange = (event) => {
    setContent(event.target.value);
  };

  const SearchByGenesHook = () => {
    async function useSearchByGenes() {
      const resp = await fetch(relativeURL("/api/search_by_genes"), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          species: species,
          nodeType: nodeType,
          contentList: content,
        }),
      });
      const body = await resp.json();
      setPathwaysResults(body);
    }

    useSearchByGenes();
  };

  return (
    <div className={css.sbgContainer}>
      <div className={css.dropdownSpeciesHP}>
        Species:{" "}
        <select
          value={species}
          onChange={(event) => setSpecies(event.currentTarget.value)}
        >
          {speciesList.map((spc) => {
            return (
              <option value={spc} key={spc}>
                {`${spc[0].toUpperCase()}. ${spc.slice(1)}`}
              </option>
            );
          })}
        </select>
      </div>
      <div style={{ placeSelf: "center" }}>
        Node type:{" "}
        <select
          value={nodeType}
          onChange={(event) => setNodeType(event.currentTarget.value)}
        >
          {availableTypes.map((nt) => {
            return (
              <option value={nt} key={nt}>
                {m[nt]}
              </option>
            );
          })}
        </select>
      </div>
      <form
        onSubmit={onSubmit}
        style={{
          placeSelf: "stretch center",
          width: "50%",
          textAlign: "center",
        }}
      >
        <textarea
          value={content}
          onChange={onChange}
          placeholder={"one entry per row..."}
          style={{ width: "100%", resize: "none", height: "80%" }}
        />
        <br />
        <input type="submit" />
      </form>
      {pathwaysResults.computing ? (
        <FontAwesomeIcon
          icon="spinner"
          size={"2x"}
          spin
          style={{ placeSelf: "center" }}
        />
      ) : (
        <TableResults
          pathwayResults={pathwaysResults}
          species={species}
          proteinType={nodeType}
        />
      )}
    </div>
  );
};

export default SearchByGenes;

const TableResults = ({ pathwayResults, species, proteinType }) => {
  const { lookup } = useLookUp();
  const [showSpinnerFetch, setShowSpinnerFetch] = useState(false);

  return (
    <div
      style={{
        placeSelf: "center",
        display: "grid",
        gridTemplateRows: "12% auto",
        gridRowGap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      <div style={{ placeSelf: "center" }}>{pathwayResults.msg}</div>
      {pathwayResults.results.length > 0 ? (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "95%",
            border: "1px solid lightgray",
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            gridRow: "2/3",
            gridColumn: "1/2",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              overflow: "auto",
            }}
          >
            <Table striped bordered hover>
              <thead>
                <tr
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "white",
                  }}
                >
                  <th>Database</th>
                  <th>Title</th>
                  <th>Count Mapping</th>
                  <th>Num. Nodes</th>
                  <th>Num. Edges</th>
                </tr>
              </thead>
              <tbody>
                {pathwayResults.results.map((row) => (
                  <tr
                    key={row.pathway_id}
                    onClick={() => {
                      setShowSpinnerFetch(true);
                      lookup(
                        species,
                        row.database,
                        row.nativeID,
                        "simple",
                        proteinType,
                        {},
                        {}
                      );
                    }}
                    className={css.resultsTableRow}
                  >
                    <td>{row.database}</td>
                    <td>{row.title}</td>
                    <td>{row.count}</td>
                    <td>{row.num_nodes}</td>
                    <td>{row.num_edges}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : null}
      {showSpinnerFetch ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            zIndex: "10",
            placeSelf: "center",
            gridRow: "2/3",
            gridColumn: "1/2",
            backgroundColor: "rgba(255,255,255,0.5)",
          }}
        >
          <Spinner size={"4x"} />
        </div>
      ) : null}
    </div>
  );
};

const availableTypes = ["ENTREZID", "SYMBOL", "UNIPROT"];

const m = { ENTREZID: "Entrez", SYMBOL: "Gene Symbol", UNIPROT: "UniProt" };

// KRAS
// HRAS
// NRAS
// PTEN
// P53
